import {Outlet} from 'react-router-dom';
import ParticipantProjectNavigation from '@/features/participants/components/ParticipantProjectNavigation';
import {useState} from 'react';
import {cn} from '@/lib/utils';
import {Menu} from 'lucide-react';

const ParticipantProjectLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen">
      <ParticipantProjectNavigation
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />
      <div
        className={cn(
          'flex-1 transition-all duration-300 overflow-x-hidden',
          // Desktop always has ml-72 to match sidebar width
          'lg:ml-72',
          // Mobile overrides when menu is open
          isMobileMenuOpen && 'ml-0 lg:ml-72'
        )}
      >
        {/* Mobile header */}
        <div className="lg:hidden bg-card border-b border-border p-4 flex items-center justify-between sticky top-0 z-30">
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 rounded-lg hover:bg-accent"
          >
            <Menu className="h-5 w-5" />
          </button>
          <h1 className="text-lg font-bold text-foreground">
            Participant Portal
          </h1>
          <div className="w-9" /> {/* Spacer for centering */}
        </div>
        <div className="p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default ParticipantProjectLayout;
